import { useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { timeAgo, formatApiError } from "@/lib/format";
import { toast } from "sonner";
import { openFile } from "@/components/undertake/ReviewTab";

const STATUS_LABEL = { open: "open", undertaken: "undertaken", sent_up: "sent up", completed: "completed" };

function DelegationItem({ d, onChanged }) {
  const { refreshUser } = useAuth();
  const [busy, setBusy] = useState(false);
  const withdraw = async () => {
    if (busy || !window.confirm("withdraw this undertaking and refund the provisions?")) return;
    setBusy(true);
    try {
      await api.delete(`/undertakings/${d.id}`);
      toast.success("withdrawn · provisions refunded");
      refreshUser?.();
      onChanged();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
      setBusy(false);
    }
  };
  return (
    <li data-testid={`delegation-item-${d.id}`} className="py-5 px-4 fade-in-up" style={{ borderBottom: "1px solid var(--border)" }}>
      <div className="flex items-center gap-3 mb-2 flex-wrap">
        <span data-testid={`delegation-status-${d.id}`} className="text-[10px] uppercase tracking-widest px-2 py-1" style={{ border: "1px solid var(--accent)", color: d.status === "completed" ? "#121212" : "var(--accent)", background: d.status === "completed" ? "var(--accent)" : "transparent" }}>
          {STATUS_LABEL[d.status] || d.status}
        </span>
        <span className="text-xs ml-auto" style={{ color: "var(--accent)" }}>{d.provisions} provisions</span>
      </div>
      <p className="long-text-sm text-sm" style={{ color: "var(--text-secondary)" }}>{d.text}</p>
      {["sent_up", "completed"].includes(d.status) && d.files?.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-3" data-testid={`delegation-files-${d.id}`}>
          {d.files.map((f) => (
            <button key={f.id} onClick={() => openFile(d.id, f)} data-testid={`delegation-file-${f.id}`} className="btn px-3 py-2 text-[10px] tracking-widest">{f.name}</button>
          ))}
        </div>
      )}
      <div className="flex items-center gap-3 mt-2 text-xs" style={{ color: "var(--text-muted)" }}>
        <span>{timeAgo(d.created_at)}</span>
        {d.undertaker_name && <span>· undertaker: {d.undertaker_name}</span>}
        {d.status === "open" && (
          <button onClick={withdraw} disabled={busy} data-testid={`delegation-withdraw-${d.id}`} className="btn ml-auto px-3 py-1 text-[10px] tracking-widest">
            {busy ? "…" : "WITHDRAW"}
          </button>
        )}
      </div>
    </li>
  );
}

export function MyDelegations({ items, onChanged }) {
  return (
    <div className="w-full max-w-3xl mt-24" data-testid="my-delegations">
      <p className="text-xs uppercase tracking-widest mb-4" style={{ color: "var(--text-muted)" }}>your delegations</p>
      {items.length === 0 ? (
        <p className="text-sm" style={{ color: "var(--text-muted)" }} data-testid="my-delegations-empty">nothing delegated yet.</p>
      ) : (
        <ul>{items.map((d) => <DelegationItem key={d.id} d={d} onChanged={onChanged} />)}</ul>
      )}
    </div>
  );
}
